var N = Object.defineProperty, k = Object.defineProperties;
var M = Object.getOwnPropertyDescriptors;
var R = Object.getOwnPropertySymbols;
var y = Object.prototype.hasOwnProperty, x = Object.prototype.propertyIsEnumerable;
var F = (t, e, n) => e in t ? N(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, E = (t, e) => {
  for (var n in e || (e = {}))
    y.call(e, n) && F(t, n, e[n]);
  if (R)
    for (var n of R(e))
      x.call(e, n) && F(t, n, e[n]);
  return t;
}, L = (t, e) => k(t, M(e));
import { useState as i, useCallback as f, useEffect as l, useRef as m, useReducer as v, useMemo as W } from "react";
import { t as j, y as w, z as H, c as z } from "./useModalStyles-de8d2ca8.js";
import { r as be, p as De, u as me, e as Oe } from "./useModalStyles-de8d2ca8.js";
import { j as B } from "./colors-cfab1b7b.js";
import { h as V, g as Y } from "./avod-d6b845d4.js";
function D(t, e) {
  if (t)
    return (n) => e.isCanceled ? n : t(n);
}
function b(t, e) {
  const n = {
    then(r, s) {
      return b(
        t.then(
          D(r, e),
          D(s, e)
        ),
        e
      );
    },
    catch(r) {
      return b(
        t.catch(D(r, e)),
        e
      );
    },
    finally(r, s) {
      return s && (e.finallyList || (e.finallyList = []), e.finallyList.push(r)), b(
        t.finally(() => (s && (e.finallyList = e.finallyList.filter(
          (a) => a !== r
        )), r())),
        e
      );
    },
    cancel() {
      e.isCanceled = !0;
      for (const r of [e.onCancelList, e.finallyList])
        if (r)
          for (; r.length; ) {
            const s = r.shift();
            typeof s == "function" && s();
          }
    },
    isCanceled() {
      return e.isCanceled === !0;
    }
  };
  return {
    then: n.then.bind(void 0),
    catch: n.catch.bind(void 0),
    finally: n.finally.bind(void 0),
    cancel: n.cancel.bind(void 0),
    isCanceled: n.isCanceled.bind(void 0)
  };
}
function U(t) {
  return b(t, {});
}
const q = (t, e) => {
  const [n, r] = i(!1), [s, a] = i(!1), [u, c] = i(), [o, h] = i(), [d, S] = i(), { onDone: A, onError: T } = e != null ? e : {}, C = f(
    (g) => {
      r(!0), c(void 0), h(void 0), a(!0);
      const O = U(t(g));
      S(O), O.then((_) => {
        h(_), r(!1), A && A(_);
      }).catch((_) => {
        c(_), h(void 0), r(!1), T && T(_);
      });
    },
    [t, T, A]
  );
  return l(() => () => d == null ? void 0 : d.cancel(), [d]), [C, n, s, o, u];
}, le = (t, e) => {
  const [n, r, s, a, u] = q(
    t,
    e
  );
  return {
    sendAction: n,
    isLoading: r,
    fired: s,
    data: a,
    error: u
  };
}, K = (t, e) => {
  const [n, r] = i(!1), [s, a] = i(), [u, c] = i(), [o, h] = i(), { onDone: d, onError: S } = e != null ? e : {}, A = f(() => {
    const C = U(t());
    return r(!0), a(void 0), C.then((g) => {
      c(g), r(!1), d && d(g);
    }).catch((g) => {
      a(g), c(void 0), r(!1), S && S(g);
    }), C;
  }, [t, S, d]);
  l(() => {
    const C = A();
    return () => C.cancel();
  }, [A]);
  const T = f(() => {
    const C = A();
    h(C);
  }, [A]);
  return l(() => () => o == null ? void 0 : o.cancel(), [o]), [u, n, s, T];
}, fe = (t, e) => {
  const [n, r, s, a] = K(t, e);
  return {
    data: n,
    isLoading: r,
    error: s,
    refresh: a
  };
}, he = (t, e) => {
  const [n, r] = i(t);
  return l(
    () => {
      const s = setTimeout(() => {
        r(t);
      }, e);
      return () => {
        clearTimeout(s);
      };
    },
    [t, e]
    // Only re-call effect if value or delay changes
  ), n;
}, X = () => {
}, Ae = (t, e = {
  interval: 5e3,
  shouldRunPolling: !0,
  runOnUnmount: !1,
  runOnInit: !1
}) => {
  const n = m(X), r = m();
  l(() => {
    n.current = t;
  }, [t]), l(() => (n.current && e.shouldRunPolling && (e.runOnInit && n.current(), r.current = setInterval(
    () => n.current(),
    e.interval
  )), () => {
    r.current && (e.runOnUnmount && n.current(), clearInterval(r.current));
  }), [
    e.interval,
    e.shouldRunPolling,
    e.runOnUnmount,
    e.runOnInit
  ]);
  const s = f(() => {
    r.current && clearInterval(r.current);
  }, []);
  return l(() => () => s(), [s]), s;
}, Ce = (t) => {
  const e = m();
  return l(() => {
    e.current = t;
  }, [t]), e.current;
}, ge = () => {
  const t = (c, o) => {
    switch (o.type) {
      case "CLEAR_ASSETS":
        return {
          assets: [],
          total: 0,
          deduplicatedAssetsCount: 0
        };
      case "ADD_ASSETS":
        return L(E({}, c), {
          assets: [...c.assets, ...o.payload]
        });
      case "SET_TOTAL_COUNT":
        return L(E({}, c), {
          total: o.payload
        });
      case "ADD_DEDUPLICATED_ASSETS_COUNT":
        return L(E({}, c), {
          deduplicatedAssetsCount: c.deduplicatedAssetsCount + o.payload
        });
      default:
        return c;
    }
  }, [e, n] = v(t, {
    assets: [],
    total: 0,
    deduplicatedAssetsCount: 0
  }), r = f((c) => {
    n({ type: "ADD_ASSETS", payload: c });
  }, []), s = f(() => {
    n({ type: "CLEAR_ASSETS" });
  }, []), a = f((c) => {
    n({ type: "SET_TOTAL_COUNT", payload: c });
  }, []), u = f(
    (c) => {
      n({
        type: "ADD_DEDUPLICATED_ASSETS_COUNT",
        payload: c
      });
    },
    []
  );
  return {
    assets: e.assets,
    totalAssetsCount: e.total,
    deduplicatedAssetsCount: e.deduplicatedAssetsCount,
    addAssets: r,
    setTotalCount: a,
    clearAssets: s,
    addDeduplicatedAssetsCount: u
  };
};
var $ = Math.max, p = Math.min;
function G(t, e, n) {
  return t >= p(e, n) && t < $(e, n);
}
var J = G, Q = J, I = j, Z = w;
function P(t, e, n) {
  return e = I(e), n === void 0 ? (n = e, e = 0) : n = I(n), t = Z(t), Q(t, e, n);
}
var ee = P, ne = H, te = z, re = "Expected a function";
function se(t, e, n) {
  var r = !0, s = !0;
  if (typeof t != "function")
    throw new TypeError(re);
  return te(n) && (r = "leading" in n ? !!n.leading : r, s = "trailing" in n ? !!n.trailing : s), ne(t, e, {
    leading: r,
    maxWait: e,
    trailing: s
  });
}
var ce = se;
const Se = ({
  frames: t,
  playerCurrentTime: e,
  animationTimeout: n
}) => {
  const [r, s] = i(), [a, u] = i(!1), c = W(
    () => ce(() => {
      if (e === void 0)
        return;
      (r && n ? e + n >= (r == null ? void 0 : r.end) : !1) && u(!0);
      const h = t.find(
        (d) => ee(e, d.start, d.end)
      );
      r !== h && (u(!1), s(h));
    }, 1e3),
    [r, e, n, t]
  );
  return l(() => {
    V(t) && s(t[0]);
  }, [t]), l(() => (c(), () => {
    c.cancel();
  }), [e, c]), { currentFrame: r, shouldUnmountCurrentFrame: a };
}, Te = ({ setPlayerTime: t }) => {
  const [e, n] = i([]), r = (u) => n((c) => [...c, u]), s = f(
    (u) => {
      t(u.end), r(u.type);
    },
    [t]
  ), a = f(
    (u) => e.some((c) => c === u),
    [e]
  );
  return { onFrameSkip: s, shouldHideFrame: a, onFrameHide: r };
}, _e = ({
  assetPlaylists: t,
  currentSecond: e,
  activePlaylist: n,
  setVideoTime: r,
  setActivePlaylist: s,
  isFinished: a
}) => {
  const [u, c] = i();
  return l(() => {
    t && c(Y(n, t));
  }, [n, t]), l(() => {
    if (!n)
      return;
    const o = (n == null ? void 0 : n.end) <= e;
    if (o && (n == null ? void 0 : n.type) === "PLAY_ADS" && (u == null ? void 0 : u.type) === "PLAY_CONTENT" && u.start > n.end) {
      const d = u.start - B;
      d > n.end && !a && r(d);
    }
    o && u && s(u);
  }, [
    e,
    t,
    n,
    r,
    s,
    u,
    a
  ]), { nextPlaylist: u };
};
export {
  be as useAssetWithContent,
  Se as useCurrentSkipFrame,
  he as useDebounce,
  K as useFetchAction,
  fe as useFetchActionObj,
  Te as useFrameSkip,
  ge as useListingAssets,
  De as useModalStyles,
  Ae as usePolling,
  Ce as usePrevious,
  q as useSendAction,
  le as useSendActionObj,
  me as useUniquePlayerId,
  _e as useVideoPlaylist,
  Oe as useWindowSize
};
//# sourceMappingURL=hooks.js.map
